"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "m11.094 8.464-4.777 5.499c-.312.36-.384.852-.186 1.284s.616.702 1.092.702h9.554c.476 0 .894-.269 1.092-.702a1.19 1.19 0 0 0-.186-1.284l-4.777-5.499a1.2 1.2 0 0 0-1.812 0"
}), 'ArrowUp');
